import styled from '@emotion/styled';
import React from 'react';
import { device, dynamicInput } from '../../../styles';

export interface IProps {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  id: string;
  label: string;
  className?: string;
}

const CheckboxInput = styled.input`
  ${dynamicInput};
`;

const TagButton = styled.div<{ checked: boolean }>`
  cursor: pointer;
  border-radius: 6px;
  border: ${(props) =>
    props.checked ? 'none' : '1px solid rgba(30, 60, 90,0.2)'};
  background-color: ${(props) =>
    props.checked ? props.theme.colors.primary : '#ffff'};
  color: ${(props) => (props.checked ? '#ffff' : props.theme.colors.primary)};
  height: 48px;
  display: flex;
  font-size: 14px;
  align-items: center;
  justify-content: center;

  padding-top: 3px;
  @media ${device.tablet} {
    font-size: 16px;
    border-radius: 24px;
  }
`;

export const TagFilterCheckbox: React.FC<IProps> = ({
  id,
  checked,
  disabled,
  label,
  onChange,
  className,
}) => {
  return (
    <>
      <CheckboxInput
        type="checkbox"
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={() => onChange(!checked)}
      />

      <label htmlFor={id}>
        <TagButton checked={checked} className={className}>
          {label}
        </TagButton>
      </label>
    </>
  );
};
